(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cupsland-1149-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var playButton = event.target.closest('[data-cupsland-video-play]');
    if (playButton) {
      var video = playButton.parentElement.querySelector('video');
      if (video) {
        video.play();
        playButton.classList.add('is-playing');
      }
    }
    var scrollButton = event.target.closest('[data-cupsland-scroll-purchase]');
    if (scrollButton) {
      var purchase = document.querySelector('.cupsland-dtc-hero__purchase');
      if (purchase) {
        event.preventDefault();
        purchase.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cupsland-about-interactive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealItems = root.querySelectorAll('.cupsland-about-interactive__reveal');
      if (reduced || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        revealItems.forEach((item) => observer.observe(item));
      }

      const turning = root.querySelector('[data-turning]');
      if (turning) {
        const slides = [...turning.querySelectorAll('[data-turning-slide]')];
        const triggers = [...turning.querySelectorAll('[data-turning-trigger]')];
        let active = 0;
        let timer;
        const show = (index) => {
          active = index;
          slides.forEach((slide, i) => {
            slide.hidden = i !== index;
            slide.classList.toggle('is-active', i === index);
          });
          triggers.forEach((trigger, i) => trigger.classList.toggle('is-active', i === index));
        };
        const restart = () => {
          if (reduced) return;
          window.clearInterval(timer);
          timer = window.setInterval(() => show((active + 1) % slides.length), 4800);
        };
        triggers.forEach((trigger, index) => trigger.addEventListener('click', () => { show(index); restart(); }));
        restart();
      }

      const belief = root.querySelector('[data-belief]');
      if (belief) {
        const triggers = [...belief.querySelectorAll('[data-belief-trigger]')];
        const visual = belief.querySelector('[data-belief-visual]');
        const title = belief.querySelector('[data-belief-title]');
        const copy = belief.querySelector('[data-belief-copy]');
        const show = (index) => {
          triggers.forEach((trigger, i) => {
            trigger.classList.toggle('is-active', i === index);
            trigger.setAttribute('aria-selected', i === index ? 'true' : 'false');
          });
          visual.dataset.beliefVisual = String(index);
          title.textContent = triggers[index].dataset.title;
          copy.textContent = triggers[index].dataset.copy;
        };
        triggers.forEach((trigger, index) => trigger.addEventListener('click', () => show(index)));
      }

      const system = root.querySelector('[data-system]');
      if (system) {
        const cards = [...system.querySelectorAll('[data-system-trigger]')];
        const title = system.querySelector('[data-system-title]');
        const copy = system.querySelector('[data-system-copy]');
        cards.forEach((card) => card.addEventListener('click', () => {
          cards.forEach((item) => item.classList.toggle('is-active', item === card));
          title.textContent = card.dataset.title;
          copy.textContent = card.dataset.copy;
        }));
      }
    };

    document.querySelectorAll('[data-cupsland-about-interactive]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-cupsland-about-interactive]')
        ? event.target
        : event.target.querySelector('[data-cupsland-about-interactive]');
      if (root) initialize(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cupsland-all-products-v2-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-cupsland-v2-categories]';

    class CupslandCategoriesCarousel {
      constructor(section) {
        this.section = section;
        this.viewport = section.querySelector('[data-carousel-viewport]');
        this.track = section.querySelector('[data-carousel-track]');
        this.previous = section.querySelector('[data-carousel-previous]');
        this.next = section.querySelector('[data-carousel-next]');
        this.controls = section.querySelector('[data-carousel-controls]');
        this.loop = section.dataset.loop === 'true';
        this.dragEnabled = section.dataset.drag === 'true';
        this.dragged = false;
        this.pointerId = null;
        this.startX = 0;
        this.startScroll = 0;
        this.frame = null;
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;

        if (!this.viewport || !this.track) return;
        this.bindEvents();
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
        this.mutationObserver = new MutationObserver(() => this.update());
        this.mutationObserver.observe(this.track, { childList: true });
        this.update();
      }

      cards() {
        return Array.from(this.track.querySelectorAll('[data-carousel-card]'));
      }

      step() {
        const cards = this.cards();
        if (cards.length < 2) return this.viewport.clientWidth;
        return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
      }

      isScrollable() {
        return this.viewport.scrollWidth > this.viewport.clientWidth + 2;
      }

      move(direction) {
        if (!this.isScrollable()) return;
        const atStart = this.viewport.scrollLeft <= 2;
        const atEnd = this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 2;
        if (this.loop && direction < 0 && atStart) {
          this.viewport.scrollTo({ left: this.viewport.scrollWidth, behavior: this.motionBehavior() });
          return;
        }
        if (this.loop && direction > 0 && atEnd) {
          this.viewport.scrollTo({ left: 0, behavior: this.motionBehavior() });
          return;
        }
        this.viewport.scrollBy({ left: this.step() * direction, behavior: this.motionBehavior() });
      }

      motionBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      update() {
        const scrollable = this.isScrollable();
        if (this.controls) this.controls.hidden = !scrollable;
        if (!this.previous || !this.next) return;
        if (this.loop && scrollable) {
          this.previous.disabled = false;
          this.next.disabled = false;
          return;
        }
        this.previous.disabled = !scrollable || this.viewport.scrollLeft <= 2;
        this.next.disabled = !scrollable || this.viewport.scrollLeft >= this.viewport.scrollWidth - this.viewport.clientWidth - 2;
      }

      bindEvents() {
        this.previous?.addEventListener('click', () => this.move(-1), { signal: this.signal });
        this.next?.addEventListener('click', () => this.move(1), { signal: this.signal });
        this.viewport.addEventListener('scroll', () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { passive: true, signal: this.signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, { signal: this.signal });

        if (!this.dragEnabled) return;
        this.viewport.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          this.pointerId = event.pointerId;
          this.startX = event.clientX;
          this.startScroll = this.viewport.scrollLeft;
          this.dragged = false;
        }, { signal: this.signal });
        this.viewport.addEventListener('pointermove', (event) => {
          if (event.pointerId !== this.pointerId) return;
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 5) {
            this.dragged = true;
            this.viewport.setPointerCapture(event.pointerId);
            this.section.classList.add('is-dragging');
          }
          if (this.dragged) this.viewport.scrollLeft = this.startScroll - distance;
        }, { signal: this.signal });
        const endDrag = (event) => {
          if (event.pointerId !== this.pointerId) return;
          this.pointerId = null;
          this.section.classList.remove('is-dragging');
          requestAnimationFrame(() => this.update());
        };
        this.viewport.addEventListener('pointerup', endDrag, { signal: this.signal });
        this.viewport.addEventListener('pointercancel', endDrag, { signal: this.signal });
        this.viewport.addEventListener('click', (event) => {
          if (!this.dragged) return;
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }, { capture: true, signal: this.signal });
      }

      revealBlock(block) {
        block?.scrollIntoView({
          behavior: this.motionBehavior(),
          block: 'nearest',
          inline: 'center'
        });
      }

      destroy() {
        this.abortController.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    }

    const initialize = (scope = document) => {
      scope.querySelectorAll(selector).forEach((section) => {
        if (section.cupslandCategoriesCarousel) return;
        section.cupslandCategoriesCarousel = new CupslandCategoriesCarousel(section);
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      section?.cupslandCategoriesCarousel?.destroy();
    });
    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest(selector);
      section?.cupslandCategoriesCarousel?.revealBlock(event.target.closest('[data-carousel-card]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cupsland-all-products-v2-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cupsland-v2-scroll]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cupsland-all-products-v2-product-grid"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=section=>{if(section.dataset.gridBound==='true')return;section.dataset.gridBound='true';const form=section.querySelector('[data-grid-form]');const automaticSort=section.querySelector('[data-grid-sort]');if(automaticSort&&form)automaticSort.addEventListener('change',()=>form.submit());const products=section.querySelector('[data-manual-products]');if(!products)return;const cards=[...products.querySelectorAll('[data-grid-card]')];cards.forEach((card,index)=>card.dataset.manualOrder=index);const availability=section.querySelector('[data-manual-availability]');const manualSort=section.querySelector('[data-manual-sort]');const count=section.querySelector('[data-manual-count]');const details=section.querySelector('[data-manual-filter]');const update=()=>{const inStock=availability?.checked;const visible=cards.filter(card=>{const show=!inStock||card.dataset.gridAvailable==='true';card.hidden=!show;return show});const sortValue=manualSort?.value||'manual';const sorted=[...visible].sort((a,b)=>{if(sortValue==='price-ascending')return Number(a.dataset.gridPrice)-Number(b.dataset.gridPrice);if(sortValue==='price-descending')return Number(b.dataset.gridPrice)-Number(a.dataset.gridPrice);return Number(a.dataset.manualOrder)-Number(b.dataset.manualOrder)});sorted.forEach(card=>products.append(card));cards.filter(card=>card.hidden).forEach(card=>products.append(card));if(count)count.textContent=`${visible.length} ${visible.length===1?'product':'products'}`};availability?.addEventListener('change',update);manualSort?.addEventListener('change',update);section.querySelector('[data-manual-clear]')?.addEventListener('click',()=>{if(availability)availability.checked=false;if(manualSort)manualSort.value='manual';if(details)details.open=false;update()});update()};document.querySelectorAll('[data-cupsland-product-grid]').forEach(init);document.addEventListener('shopify:section:load',event=>{const section=event.target.matches('[data-cupsland-product-grid]')?event.target:event.target.querySelector('[data-cupsland-product-grid]');if(section)init(section)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cupsland-product-hero-dtc"] && !Shopify.designMode) return;
  try {
    
  const updateCupslandDtcGallery = (gallery, index) => {
    const thumbnails = [...gallery.querySelectorAll('[data-cupsland-dtc-thumb]')];
    const itemCount = thumbnails.length + 1;
    const normalizedIndex = (index + itemCount) % itemCount;
    const selectedThumbnail = normalizedIndex === 0 ? null : thumbnails[normalizedIndex - 1];
    const desktopSrc = selectedThumbnail ? selectedThumbnail.dataset.desktopSrc : gallery.dataset.mainDesktopSrc;
    const mobileSrc = selectedThumbnail ? selectedThumbnail.dataset.mobileSrc : gallery.dataset.mainMobileSrc;
    const alt = selectedThumbnail ? selectedThumbnail.dataset.imageAlt : gallery.dataset.mainAlt;
    const mainImage = gallery.querySelector('[data-cupsland-dtc-main-image]');
    const mainSource = gallery.querySelector('[data-cupsland-dtc-main-source]');
    if (!mainImage) return;
    mainImage.src = desktopSrc;
    mainImage.srcset = `${desktopSrc} 1600w`;
    if (mainSource) mainSource.srcset = `${mobileSrc || desktopSrc} 1000w`;
    mainImage.alt = alt || '';
    gallery.dataset.currentIndex = normalizedIndex;
    thumbnails.forEach((item, thumbnailIndex) => {
      const isActive = thumbnailIndex === normalizedIndex - 1;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };
  const setCupslandBundleState = (section, option) => {
    const gallery = section.querySelector('[data-cupsland-dtc-gallery]');
    const buttons = [...section.querySelectorAll('[data-cupsland-bundle-option]')];
    const note = section.querySelector('[data-cupsland-bundle-note]');
    const currentPrice = section.querySelector('[data-cupsland-current-price]');
    const comparePrice = section.querySelector('[data-cupsland-compare-price]');
    const addButton = section.querySelector('[data-cupsland-add-to-cart]');
    const addLabel = section.querySelector('[data-cupsland-add-label]');
    const additionalId = section.querySelector('[data-cupsland-additional-id]');
    const additionalQuantity = section.querySelector('[data-cupsland-additional-quantity]');
    const isBundle = option === 'hands-free-ready';
    const price = isBundle ? section.dataset.bundlePrice : section.dataset.devicePrice;
    const compare = isBundle ? section.dataset.bundleComparePrice : section.dataset.deviceComparePrice;
    const showCompare = (isBundle ? section.dataset.bundleCompareVisible : section.dataset.deviceCompareVisible) === 'true';
    const available = (isBundle ? section.dataset.bundleAvailable : section.dataset.deviceAvailable) === 'true';
    section.dataset.cupslandBundleSelection = option;
    buttons.forEach((button) => {
      const isSelected = button.dataset.cupslandBundleOption === option;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
    if (currentPrice) currentPrice.textContent = price;
    if (comparePrice) {
      comparePrice.textContent = compare;
      comparePrice.hidden = !showCompare;
    }
    if (additionalId) {
      additionalId.value = isBundle ? section.dataset.handsFreeVariantId : '';
      additionalId.disabled = !isBundle;
    }
    if (additionalQuantity) {
      additionalQuantity.value = isBundle ? '1' : '';
      additionalQuantity.disabled = !isBundle;
    }
    if (addButton) addButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? `${section.dataset.addToCartLabel} - ${price}` : 'Sold out';
    if (note) note.hidden = !isBundle;
    if (!gallery) return;
    if (option === 'device') {
      updateCupslandDtcGallery(gallery, 0);
      return;
    }
    const desktopSrc = gallery.dataset.handsFreeReadyDesktopSrc;
    const mobileSrc = gallery.dataset.handsFreeReadyMobileSrc || desktopSrc;
    const mainImage = gallery.querySelector('[data-cupsland-dtc-main-image]');
    const mainSource = gallery.querySelector('[data-cupsland-dtc-main-source]');
    if (!desktopSrc || !mainImage) return;
    mainImage.src = desktopSrc;
    mainImage.srcset = `${desktopSrc} 1600w`;
    mainImage.alt = gallery.dataset.handsFreeReadyAlt || '';
    if (mainSource) mainSource.srcset = `${mobileSrc} 1000w`;
    gallery.dataset.currentIndex = '0';
    gallery.querySelectorAll('[data-cupsland-dtc-thumb]').forEach((thumbnail) => {
      thumbnail.classList.remove('is-active');
      thumbnail.setAttribute('aria-current', 'false');
    });
  };
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cupsland-extra-media-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.cupslandExtraMediaOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const closeButton = event.target.closest('[data-cupsland-extra-media-close]');
    if (closeButton) {
      const dialog = closeButton.closest('dialog');
      dialog.querySelectorAll('video').forEach((video) => video.pause());
      dialog.close();
      return;
    }
    const arrow = event.target.closest('[data-cupsland-gallery-direction]');
    if (arrow) {
      const gallery = arrow.closest('[data-cupsland-dtc-gallery]');
      const currentIndex = Number.parseInt(gallery.dataset.currentIndex || '0', 10);
      const change = arrow.dataset.cupslandGalleryDirection === 'previous' ? -1 : 1;
      updateCupslandDtcGallery(gallery, currentIndex + change);
      return;
    }
    const thumbnail = event.target.closest('[data-cupsland-dtc-thumb]');
    if (thumbnail) {
      const gallery = thumbnail.closest('[data-cupsland-dtc-gallery]');
      const thumbnailIndex = [...gallery.querySelectorAll('[data-cupsland-dtc-thumb]')].indexOf(thumbnail);
      updateCupslandDtcGallery(gallery, thumbnailIndex + 1);
      return;
    }
    const bundleOption = event.target.closest('[data-cupsland-bundle-option]');
    if (!bundleOption) return;
    const section = bundleOption.closest('.cupsland-dtc-hero');
    if (!section) return;
    setCupslandBundleState(section, bundleOption.dataset.cupslandBundleOption);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.cupsland-dtc-hero__form');
    const submitter = event.submitter;
    if (!form || !submitter || !submitter.matches('[data-cupsland-add-to-cart]')) return;
    event.preventDefault();
    const section = form.closest('.cupsland-dtc-hero');
    const message = form.querySelector('[data-cupsland-cart-message]');
    const isBundle = section.dataset.cupslandBundleSelection === 'hands-free-ready';
    const deviceVariantId = Number.parseInt(section.dataset.deviceVariantId, 10);
    const handsFreeVariantId = Number.parseInt(section.dataset.handsFreeVariantId, 10);
    const items = [{ id: deviceVariantId, quantity: 1 }];
    if (isBundle) items.push({ id: handsFreeVariantId, quantity: 1 });
    if (items.some((item) => !Number.isInteger(item.id))) return;
    submitter.disabled = true;
    if (message) {
      message.hidden = true;
      message.textContent = '';
    }
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this selection to the cart.');
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'cupsland-dtc-hero', items: result.items } }));
      if (message) {
        message.textContent = 'Added to cart.';
        message.hidden = false;
      }
    } catch (error) {
      if (message) {
        message.textContent = error.message;
        message.hidden = false;
      }
    } finally {
      const selection = section.dataset.cupslandBundleSelection;
      const available = (selection === 'hands-free-ready' ? section.dataset.bundleAvailable : section.dataset.deviceAvailable) === 'true';
      submitter.disabled = !available;
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.matches('.cupsland-dtc-hero__media-dialog')) {
      event.target.querySelectorAll('video').forEach((video) => video.pause());
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
